import type { ResponseMachinePositionHistories } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';

export interface EquipmentPositionSummary {
  id: string;
  address?: string;
  placeId?: string;
  latitude: number;
  longitude: number;
  accuracy: number;
  enteredAt: string;
  exitedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface MachinePositionHistoriesListResponse {
  machinePositionHistories?: ResponseMachinePositionHistories | null;
}

export const MACHINE_POSITION_HISTORY_PAGE_SIZE = 10;
